
<div class="sidebar">
  <p class="admin-back-link">
    ← <a routerLink="/users" i18n="Back to Admin|A link to return the user back to the admin section@@inviteSideBarBackToAdminLink">Back to admin</a>
  </p>
  <div class="gdpr-links">
    <ul>
      <li><a id="admin-privacy-policy-link" class="sidebar-gdpr" href="/privacy-policy/" target="_blank" i18n="Privacy Policy|privacy policy link@@privacyPolicyLink" title="Privacy Policy">Privacy Policy</a></li>
      <li><a id="admin-terms-and-conditions-link" class="sidebar-gdpr" href="/terms-and-conditions/" i18n="Terms and conditions|terms and conditions link@@termsAndConditionsLink" title="Terms and Conditions" target="_blank">Terms and Conditions</a></li>
      <li><a id="admin-cookie-policy-link" class="sidebar-gdpr" href="/cookie-policy/" i18n="Cookie Policy|cookie policy link@@cookiePolicyLink" title="Cookie Policy" target="_blank">Cookie policy</a></li>
    </ul>
  </div>
</div>
